'use client';

import React, { useEffect, useRef } from 'react';
import { css, cx } from 'styled-system/css';
import { scrollbar } from 'styled-system/recipes';

import { useDomStore } from '@shaojiang/store/dom';

interface Props {
  children: React.ReactNode;
}

/** The main scroll container. Mirrors its scrollTop into the dom store (header, scroll-to-top). */
export default function ScrollTopHolder({ children }: Props) {
  const holderRef = useRef<HTMLDivElement>(null);
  const scrollTop = useDomStore((state) => state.scrollTop);
  const setScrollTop = useDomStore((state) => state.setScrollTop);

  useEffect(() => {
    const holder = holderRef.current;
    if (!holder) return;
    const onScroll = () => setScrollTop(holder.scrollTop);
    holder.addEventListener('scroll', onScroll, { passive: true });
    return () => holder.removeEventListener('scroll', onScroll);
  }, [setScrollTop]);

  useEffect(() => {
    if (holderRef.current && holderRef.current.scrollTop !== scrollTop) {
      holderRef.current.scrollTop = scrollTop;
    }
  }, [scrollTop]);

  return (
    <div
      ref={holderRef}
      className={cx(
        scrollbar(),
        css({ flex: '1', px: '4', lgDown: { p: '0' }, height: 'full', position: 'relative' }),
      )}
    >
      {children}
    </div>
  );
}
